import { useCallback, useState } from 'react';
import { useAuthInfoProvider } from 'content-management-data-lib';
import { ActionsCollapser } from 'foundations-components/transitional/components/ActionsCollapser';
import { checkPermissions } from '../utils/permissions';
import { useContentActions } from '../providers/ContentActionsProvider';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { usePermissionsExtraData } from '../providers/PermissionsExtraDataProvider';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BulkActionButton = ({
  action: {
    id,
    name,
    BulkInlineActionIcon,
    displayPermissions,
    enablePermissions,
    DisabledTooltipContent,
    permissionsExtraData: permissionsExtraDataForAction
  },
  handleActionButtonClick,
  crmObjects,
  gates,
  scopes
}) => {
  const permissionsExtraDataForPlatform = usePermissionsExtraData();
  const permissionsExtraData = Object.assign({}, permissionsExtraDataForPlatform, permissionsExtraDataForAction);
  const actionIsDisplayed = checkPermissions({
    permissions: displayPermissions,
    scopes,
    gates,
    crmObjects,
    isBulkAction: true,
    permissionsExtraData
  });
  if (!actionIsDisplayed) {
    return null;
  }
  const actionIsEnabled = checkPermissions({
    permissions: enablePermissions,
    scopes,
    gates,
    crmObjects,
    isBulkAction: true,
    permissionsExtraData
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: actionIsEnabled,
    placement: "right bottom",
    title: DisabledTooltipContent ? /*#__PURE__*/_jsx(DisabledTooltipContent, {
      crmObjects: crmObjects,
      permissionsExtraData: permissionsExtraData,
      scopes: scopes,
      gates: gates
    }) : null,
    children: /*#__PURE__*/_jsxs(Button, {
      disabled: !actionIsEnabled,
      use: "transparent",
      onClick: handleActionButtonClick,
      "data-test-id": `${id}-bulk-action-button`,
      marginInlineStart: "0",
      children: [BulkInlineActionIcon ? /*#__PURE__*/_jsx(BulkInlineActionIcon, {
        color: "icon-core-subtle"
      }) : null, name]
    })
  });
};
const ContentBulkActions = ({
  crmObjects
}) => {
  const {
    contentBulkActions
  } = useContentActions();
  const [currentAction, setCurrentAction] = useState(undefined);
  const [isModalOrPanelOpen, setIsModalOrPanelOpen] = useState(false);
  const handleActionButtonClick = useCallback(action => {
    setCurrentAction(action);
    if (action.ModalOrPanel) {
      setIsModalOrPanelOpen(true);
      return;
    }
  }, []);
  const {
    userInfo: {
      gates,
      user: {
        scopes
      }
    }
  } = useAuthInfoProvider();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isModalOrPanelOpen && currentAction && currentAction.ModalOrPanel ? /*#__PURE__*/_jsx(currentAction.ModalOrPanel, {
      crmObjects: crmObjects,
      gates: gates,
      scopes: scopes,
      onClose: () => {
        setIsModalOrPanelOpen(false);
        setCurrentAction(undefined);
      }
    }) : null, /*#__PURE__*/_jsx(ActionsCollapser, {
      dropdownProps: {
        buttonUse: 'transparent',
        buttonStyles: {
          paddingInlineStart: '0'
        }
      },
      children: contentBulkActions.map(action => /*#__PURE__*/_jsx(BulkActionButton, {
        action: action,
        handleActionButtonClick: () => handleActionButtonClick(action),
        gates: gates,
        scopes: scopes,
        crmObjects: crmObjects
      }, action.id))
    })]
  });
};
export default ContentBulkActions;